export const getTrailingSlashUrl = (url) => {
  if (url) {
    if (url.endsWith("/")) {
      return `${url.slice(0, -1)}`;
    }
  }
  return url;
};

export const getQueryParamsFromUrl = (url) => {
  const { queryParams: query } = url || {};
  return query === null ? "" : query;
};

export const getBasePathFromUrl = (url, isProjectPage) => {
  const { basePath } = url || {};
  if (isProjectPage && !basePath?.includes("/projeler/")) {
    const projectPagePath = basePath?.concat("projeler/");
    return projectPagePath;
  }
  return basePath;
};

export const createPaginationUrl = ({ url, page, isProjectPage }) => {
  const pageNumber = parseInt(page, 10);
  const basePath = getBasePathFromUrl(url, isProjectPage);
  const trailingSlashUrl = getTrailingSlashUrl(basePath);
  let queryParams = getQueryParamsFromUrl(url).replace(/^\?/, "");

  let newQueryParams = queryParams;

  if (pageNumber > 1) {
    const sayfaParam = `sayfa=${pageNumber}`;
    newQueryParams = queryParams ? `${queryParams}&${sayfaParam}` : sayfaParam;
  }

  const finalUrl = newQueryParams ? `${trailingSlashUrl}?${newQueryParams}` : trailingSlashUrl;

  return finalUrl;
};

export const normalizeUrl = (url, trailing = true) => {
  if (url) {
    let baseUrl = url.split("?")[0];
    let query = url.split("?")[1];
    const regexUrl =
      /^\/(satilik-[a-z-]+|kiralik-[a-z-]+|gunluk-kiralik-[a-z-]+|kat-karsiligi-arsa|devren-isyeri)(\/[^/]*)*\/?$/;
    const regexForLandingPage = /^\/([a-zA-Z0-9-]+(?:\/[a-zA-Z0-9-]+)*\-lp\/?)$/;
    if (regexUrl.test(url) || regexForLandingPage.test(url)) {
      if (baseUrl.endsWith("/")) {
        baseUrl = baseUrl.slice(0, -1);
      }
      return query ? `${baseUrl}?${decodeURIComponent(query)}` : `${baseUrl}`;
    }
    if (baseUrl.substr(-1) !== "/") {
      return query ? `${baseUrl}/?${decodeURIComponent(query)}` : trailing ? `${baseUrl}/` : `${baseUrl}`;
    }
    return url;
  }
  return url;
};
export const addParameterToURL = (param, url) => {
  if (typeof url !== "string") return "";
  if (url.includes(param)) return url;
  const isMapView = param === "view_type=map" || url.includes("bottom_left");
  return isMapView
    ? `${url}${url.split("?")[1] ? "&" : "?"}view_type=map`
    : `${url}/${url.split("?")[1] ? "&" : "?"}view_type=map`;
};

export const isListingUrlControl = (param) => {
  const controller = /^(?!\/ilan)\/(satilik|kiralik|kat-karsiligi|devren|gunluk-kiralik)-([A-Za-z0-9\\-\\.]+)(\/)?.*/;
  return controller.test(param);
};

export const getUrlEncodedComponent = (component) => encodeURIComponent(component);

export const normalizeQueryEncoding = (query) => {
  if (query == null) return "";

  const queryValue = String(query);
  const hasQuestion = queryValue.startsWith("?");
  const core = (hasQuestion ? queryValue.slice(1) : queryValue)
    .replace(/%5B%5D/gi, "[]")
    .replace(/%3D/gi, "=")
    .replace(/%2C/gi, ",")
    .replace(/%26/gi, "&");

  return core ? (hasQuestion ? `?${core}` : core) : "";
};
